import {
  Future,
  resolvedFuture,
} from 'external/dev_april_corgi+/js/common/futures';

import init, {evaluate as rustEvaluate} from 'petri/logic/wasm/wasm';

interface HoldTemperatureAction {
  kind: 'hold_temperature';
  durationS: number;
  temperatureC: number;
}

interface TakeAliquotsAction {
  kind: 'take_aliquots';
  suffix: string;
}

type Action = HoldTemperatureAction | TakeAliquotsAction;

const starlark = resolvedFuture(undefined)
  .then(() => {
    if (process.env.CORGI_FOR_BROWSER) {
      return fetch('/static/wasm_bg.wasm').then(r => r.bytes());
    } else {
      return import('node:fs').then(
        fs =>
          new Uint8Array([
            ...fs.readFileSync('petri/logic/wasm/wasm_bg.wasm').values(),
          ]),
      );
    }
  })
  .then(module => init({module_or_path: module}))
  .then(() => new Starlark());

class Starlark {
  evaluate(script: string, options: {canThermocycle: boolean}): Action[] {
    const result = rustEvaluate(script, options.canThermocycle);
    return JSON.parse(result);
  }
}

export function ready(): Future<Starlark> {
  return starlark;
}
